export default __webpack_public_path__ + "static/media/Festrahmentür BS-BA.d732f98f.jpg";